<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="innerVisible"
    width="92%"
    top="4vh"
    append-to-body
    class="handover-form-dialog"
    @closed="resetForm"
  >
    <div v-loading="loading">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px" size="small">
        <div class="section-title">基础信息</div>
        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item label="记录日期" prop="recordDate">
              <el-date-picker v-model="form.recordDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="班组" prop="teamNo">
              <el-select v-model="form.teamNo" filterable clearable placeholder="请选择" @change="handleTeamChange">
                <el-option v-for="item in teamOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="班次" prop="shiftNo">
              <el-select v-model="form.shiftNo" filterable clearable placeholder="请选择" @change="handleShiftChange">
                <el-option v-for="item in shiftOptions" :key="item.shiftNo" :label="item.shiftName" :value="item.shiftNo" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="时间段">
              <el-input :value="timeRange" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="记录人">
              <el-input :value="form.recordUserName || currentUserName" disabled />
            </el-form-item>
          </el-col>
        </el-row>

        <div class="section-title">生产情况汇总</div>
        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item label="作业车列数" prop="workTrainCount">
              <el-input-number v-model="form.workTrainCount" :min="0" :precision="0" controls-position="right" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="作业车节数" prop="workCarCount">
              <el-input-number v-model="form.workCarCount" :min="0" :precision="0" controls-position="right" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="热电卸煤量" prop="thermalPowerUnloadWeight">
              <el-input-number v-model="form.thermalPowerUnloadWeight" :min="0" :precision="3" controls-position="right" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="煤棚卸煤量" prop="coalShedUnloadWeight">
              <el-input-number v-model="form.coalShedUnloadWeight" :min="0" :precision="3" controls-position="right" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="form.remark" type="textarea" :rows="3" maxlength="500" show-word-limit />
            </el-form-item>
          </el-col>
        </el-row>

        <div class="section-title section-title--with-action">
          <span>交接班记录明细</span>
          <el-button type="primary" icon="el-icon-plus" size="small" @click="addItem">添加明细</el-button>
        </div>
        <el-table :data="form.itemList" border size="small" empty-text="暂无明细，可直接保存基础信息">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column label="时间" width="150">
            <template slot-scope="{ row }">
              <el-time-picker v-model="row.recordTime" value-format="HH:mm" format="HH:mm" placeholder="HH:mm" />
            </template>
          </el-table-column>
          <el-table-column label="工作内容" min-width="220">
            <template slot-scope="{ row }">
              <el-input v-model="row.workContent" maxlength="500" placeholder="请输入" />
            </template>
          </el-table-column>
          <el-table-column label="处理情况" min-width="200">
            <template slot-scope="{ row }">
              <el-input v-model="row.handleStatus" maxlength="500" placeholder="请输入" />
            </template>
          </el-table-column>
          <el-table-column label="交接事项" min-width="200">
            <template slot-scope="{ row }">
              <el-input v-model="row.handoverMatter" maxlength="500" placeholder="请输入" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="90" align="center">
            <template slot-scope="{ $index }">
              <el-button type="text" size="small" class="danger-text" @click="removeItem($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="small" @click="innerVisible = false">取消</el-button>
      <el-button type="primary" size="small" :loading="saving" @click="submit">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDetail, getShiftListByTeam, save, update } from "../api";

function today() {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
}

function emptyForm(userInfo = {}) {
  return {
    recordDate: today(),
    teamNo: "",
    teamName: "",
    shiftNo: "",
    shiftName: "",
    startTime: "",
    endTime: "",
    recordUserId: userInfo.user_id || userInfo.userId || "",
    recordUserName: userInfo.real_name || userInfo.realName || userInfo.nick_name || userInfo.nickName || userInfo.account || "",
    workTrainCount: 0,
    workCarCount: 0,
    thermalPowerUnloadWeight: 0,
    coalShedUnloadWeight: 0,
    remark: "",
    itemList: [],
  };
}

function hasItemValue(row) {
  return ["recordTime", "workContent", "handleStatus", "handoverMatter"].some((key) => String(row[key] || "").trim());
}

export default {
  name: "HandoverFormDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "add",
    },
    recordId: {
      type: [String, Number],
      default: "",
    },
    teamOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const nonNegative = (rule, value, callback) => {
      if (value === "" || value === null || value === undefined) {
        callback();
        return;
      }
      Number(value) < 0 ? callback(new Error("不能小于0")) : callback();
    };
    return {
      loading: false,
      saving: false,
      shiftOptions: [],
      form: emptyForm(this.$store.getters.userInfo || {}),
      rules: {
        recordDate: [{ required: true, message: "请选择记录日期", trigger: "change" }],
        teamNo: [{ required: true, message: "请选择班组", trigger: "change" }],
        shiftNo: [{ required: true, message: "请选择班次", trigger: "change" }],
        workTrainCount: [{ validator: nonNegative, trigger: "change" }],
        workCarCount: [{ validator: nonNegative, trigger: "change" }],
        thermalPowerUnloadWeight: [{ validator: nonNegative, trigger: "change" }],
        coalShedUnloadWeight: [{ validator: nonNegative, trigger: "change" }],
      },
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    dialogTitle() {
      return this.mode === "edit" ? "编辑交接班记录" : "新增交接班记录";
    },
    currentUserName() {
      const userInfo = this.$store.getters.userInfo || {};
      return userInfo.real_name || userInfo.realName || userInfo.nick_name || userInfo.nickName || userInfo.account || "";
    },
    timeRange() {
      return this.form.startTime && this.form.endTime ? `${this.form.startTime}-${this.form.endTime}` : "";
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.open();
      }
    },
  },
  methods: {
    async open() {
      this.form = emptyForm(this.$store.getters.userInfo || {});
      this.shiftOptions = [];
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
      if (this.mode !== "edit" || !this.recordId) {
        return;
      }
      this.loading = true;
      try {
        const res = await getDetail(this.recordId);
        const data = (res.data && res.data.data) || {};
        this.form = {
          ...emptyForm(this.$store.getters.userInfo || {}),
          ...data,
          itemList: (data.itemList || []).map((item) => ({ ...item })),
        };
        if (this.form.teamNo) {
          await this.loadShiftOptions(this.form.teamNo);
        }
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.form = emptyForm(this.$store.getters.userInfo || {});
      this.shiftOptions = [];
      this.saving = false;
    },
    async loadShiftOptions(teamNo) {
      if (!teamNo) {
        this.shiftOptions = [];
        return;
      }
      const res = await getShiftListByTeam(teamNo);
      this.shiftOptions = (res.data && res.data.data) || [];
    },
    handleTeamChange(teamNo) {
      const team = this.teamOptions.find((item) => item.dictKey === teamNo) || {};
      this.form.teamName = team.dictValue || "";
      this.form.shiftNo = "";
      this.form.shiftName = "";
      this.form.startTime = "";
      this.form.endTime = "";
      this.loadShiftOptions(teamNo);
    },
    handleShiftChange(shiftNo) {
      const shift = this.shiftOptions.find((item) => item.shiftNo === shiftNo) || {};
      this.form.shiftName = shift.shiftName || "";
      this.form.startTime = shift.startTime || "";
      this.form.endTime = shift.endTime || "";
    },
    addItem() {
      this.form.itemList.push({
        recordTime: "",
        workContent: "",
        handleStatus: "",
        handoverMatter: "",
      });
    },
    removeItem(index) {
      this.form.itemList.splice(index, 1);
    },
    buildPayload() {
      const itemList = (this.form.itemList || [])
        .filter((item) => hasItemValue(item))
        .map((item, index) => ({
          ...item,
          itemSort: index + 1,
          recordTime: item.recordTime,
          workContent: String(item.workContent || "").trim(),
          handleStatus: String(item.handleStatus || "").trim(),
          handoverMatter: String(item.handoverMatter || "").trim(),
        }));
      return {
        id: this.form.id,
        recordDate: this.form.recordDate,
        teamNo: this.form.teamNo,
        teamName: this.form.teamName,
        shiftNo: this.form.shiftNo,
        shiftName: this.form.shiftName,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        workTrainCount: this.form.workTrainCount,
        workCarCount: this.form.workCarCount,
        thermalPowerUnloadWeight: this.form.thermalPowerUnloadWeight,
        coalShedUnloadWeight: this.form.coalShedUnloadWeight,
        remark: this.form.remark,
        itemList,
      };
    },
    validateItems() {
      const list = this.form.itemList || [];
      for (let i = 0; i < list.length; i += 1) {
        const item = list[i];
        if (!hasItemValue(item)) {
          continue;
        }
        if (!item.recordTime) {
          this.$message.warning(`第 ${i + 1} 条明细请填写时间`);
          return false;
        }
        if (!String(item.workContent || "").trim()) {
          this.$message.warning(`第 ${i + 1} 条明细请填写工作内容`);
          return false;
        }
      }
      return true;
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid || !this.validateItems()) {
          return;
        }
        this.saving = true;
        try {
          const payload = this.buildPayload();
          const request = payload.id ? update : save;
          await request(payload);
          this.$message.success("保存成功");
          this.innerVisible = false;
          this.$emit("success");
        } finally {
          this.saving = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.handover-form-dialog {
  ::v-deep .el-dialog__body {
    max-height: 72vh;
    overflow: auto;
  }

  ::v-deep .el-date-editor,
  ::v-deep .el-select,
  ::v-deep .el-input-number {
    width: 100%;
  }
}

.section-title {
  display: flex;
  align-items: center;
  margin: 4px 0 14px;
  padding-left: 8px;
  border-left: 3px solid #409eff;
  color: #1f2d3d;
  font-size: 15px;
  font-weight: 700;
  line-height: 18px;
}

.section-title--with-action {
  justify-content: space-between;
  margin-top: 18px;
}

.danger-text {
  color: #f56c6c;
}
</style>
